
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.333 7.703c-.382 0-.7.32-.7.705v3.758c0 .384.318.704.7.704v1.822c-.382 0-.7.31-.7.704v2.03a.568.568 0 01-.568.574H5.647C3.642 18 2 16.356 2 14.326V11.92c0-.394.327-.667.71-.667a1.251 1.251 0 001.24-1.259c0-.667-.541-1.174-1.25-1.174a.7.7 0 01-.7-.705V5.683C2 3.653 3.642 2 5.657 2h6.408c.317 0 .569.253.569.573v2.405c0 .386.317.705.7.705v2.02zM17.584 11.254c-.4-.01-.727-.564-.727-1.26 0-.684.328-1.249.733-1.249.11 0 .213-.075.29-.206.076-.13.12-.31.12-.498V5.674C18 3.644 17.043 2 15.861 2h-1.784c-.18 0-.333.254-.333.574v2.404c0 .386-.18.705-.41.705v2.02c.23 0 .41.32.41.705v3.758c0 .384-.18.704-.41.704v1.822c.23 0 .41.31.41.705v2.029c0 .32.153.574.334.574h1.783C17.043 18 18 16.356 18 14.326V11.91c0-.385-.192-.657-.416-.657z","fill":"#94A3B8"}})])
          )
        }
      }
    